export interface Dashboard {
    data: any
    total: number
}

export interface DataTotal {
    data: any
    total: number
}

export interface DataForChart {
    labels: Array<string>
    datasets: Array<DataSet>
}

export interface DataSet {
    data: Array<number>
    backgroundColor: Array<string>
    hoverBackgroundColor: Array<string>
    borderColor?: Array<string>
    borderWidth?: number
}

export interface IncidentBacklog {
    _id: string
    slaGoalName?: string
    measurementClockStartTime?: string
    slaTargetTime?: string
    slaTag?: string
    slaPolicyName?: string
    number: string
    subject: string
    priority: string
    status: string
    supportTeam: string
    assignee: string
    createdDatetime: string
    ticketId: string
}

export enum ChartType {
    OpenTicket = 'open-ticket',
    OpenByStatus = 'status',
    OpenByPriority = 'priority',
    OpenSLA = 'sla',
    IncidentBacklog = 'incidentBacklog',
    Responded = 'responded',
    Remainder = 'remaining',
    TopLikeKm = 'topLikeKm',
    TopCreateKm = 'topCreateKm',
    TotalPublishKm = 'totalPublishKm'
}

export enum GroupType {
    TotalGroup = 'TotalGroup',
    MyGroup = 'MyGroup',
    MyTicket = 'MyTicket',
}

export const Color = [
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163',
    '#EF701F', '#EFD658', '#1CBB9F', '#0890C2', '#606163'
]

// Complete  4DC977
// Due in 2F80ED
// Due soon ED9E28
// Missed EB5757
// Overdue #726E6D

export const ColorSLA = ['#4DC977', '#2F80ED', '#ED9E28', '#EB5757', '#726E6D']

export interface KnowledgeDashboard {
    totalPublishKm: number,
    topCreateKm: TopCreateKMDashboard[]
    topLikeKm: TopLikeKMDashboard
    topViewKm: TopViewKMDashboard
}

export interface TopCreateKMDashboard {
    ordinalNumber: number,
    amountCreated: number,
    authors: author[]

}

export interface TopLikeKMDashboard {
    topLikeKm: topLikeKmData[],
    totalKmTopLike: number
}

export interface Km {
    ticketNumber: string,
    createdBy: string,
}

export interface author {
    id: number,
    firstName: string,
    lastName: string,
    fullName: string,
    email: string,
    pictureProfile?: string
}

export interface topLikeKmData {
    ordinalNumber: number,
    amountLike: number,
    knowledges: Km[]
}

export interface imageTopcreate {
    name?: string,
    status?: string,
    url?: string,
    type?: string,
    size?: number
}

export interface TopViewKMDashboard {
    topViewKm: topViewKmData[],
    totalKmTopView: number
}

export interface topViewKmData {
    ordinalNumber: number,
    amountView: number,
    knowledges: Km[]
}

export const ColortotalPubKm = ['#2F80ED']

export const ColorToplikeKm = ['#FAAD14', '#69BB57', '#F6712E']

export interface importAssetResponseDetails {
    messageFail?: string
    rowAssetGroupMismatch?: number[]
    rowExceedLength?: keyImportAssetResponseDetails
    rowInvalid?: keyImportAssetResponseDetails
    rowIsNull?: keyImportAssetResponseDetails
    rowNotFound?: keyImportAssetResponseDetails
    rowSerialNumberInvalidChar?: number[]
}

export interface keyImportAssetResponseDetails {
    assetGroup?: number[]
    assetName?: number[]
    assetStatus?: number[]
    assetTag?: number[]
    brand?: number[]
    dateInService?: number[]
    expiryDate?: number[]
    location?: number[]
    manufacturer?: number[]
    model?: number[]
    ownerId?: number[]
    pairedITAsset?: number[]
    poNumber?: number[]
    serialNumber?: number[]
    type?: number[]
    zone?: number[]
    customFields?: {
        [key: string]: number[]
    }
}

export const mapFieldsAssetImport = (text: string): string  => {
    switch (text) {
        case 'assetGroup':
            return 'Asset Group'
        case 'assetName':
            return 'Asset Name'
        case 'assetStatus':
            return 'Asset Status'
        case 'assetTag':
            return 'Asset Tag'
        case 'brand':
            return 'Brand'
        case 'dateInService':
            return 'Date In Service'
        case 'expiryDate':
            return 'Expiry Date'
        case 'location':
            return 'Location'
        case 'manufacturer':
            return 'Manufacturer'
        case 'model':
            return 'Model'
        case 'ownerId':
            return 'Owner'
        case 'pairedITAsset':
            return 'Paired IT Asset'
        case 'poNumber':
            return 'PO Number'
        case 'serialNumber':
            return 'Serial Number'
        case 'type':
            return 'Type'
        case 'zone':
            return 'Zone'
        case 'site':
            return 'Site'
        case 'building':
            return 'Building'
        case 'floor':
            return 'Floor'
        default:
            return text
    }
}
